if ( $('.header-search-form').length ) {
  $('.search-form label').append('Search Form');
}


window.onload = function() {
  if ( $('.goog-te-combo').length ) {
    $('.goog-te-gadget > div').prepend('<label for="google-trans-select">Change Language</label');
    $('.goog-te-gadget select')[0].setAttribute("id", "google-trans-select");
    $('.goog-te-gadget option:first-child').text('Language');
  }

}

$(function() {
  if ( $('body.tribe-theme-child-figpress-child').length ) {
    var tribeHeader = $('body.tribe-theme-child-figpress-child .catch-all > h1');
    var tribePage = $('body.tribe-theme-child-figpress-child');
    tribeHeader.append('Providence Events');
    tribeHeader.addClass('hidden-item');

    $('select.tribe-bar-views-select')[0].setAttribute('id', 'calendar-select-display');
    $('.tribe-bar-views-inner > label')[0].setAttribute('for', 'calendar-select-display');
  }

});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/custom/ada.js